import { RootState, RootActions } from "common/reducers";
import { List, Record } from "immutable";
import { ProviaOrderSummaryRecord, proviaOrderSummaryFromJSON } from "common/records/ProviaOrderSummaryRecord";
import { ProViaOrder2Record, proViaOrder2FromJSON } from "common/records/ProViaOrder2Record";
import {
  SET_PROVIA_LOADING,
  RECEIVE_PROVIA_ORDERS,
  RECEIVE_PROVIA_ORDER,
  RESET_PROVIA_STATE,
  OPEN_PROVIA_MODAL,
} from "common/reducers/provia.actions";

export const ProViaStateRecord = Record({
  loading: false,
  orders: null as List<ProviaOrderSummaryRecord> | null,
  order: null as ProViaOrder2Record | null,
  error: null as string | null,
  modalMode: null as "portal" | "non_portal" | null,
  modalEstimateGroupId: null as number | null,
});

export const initialState = ProViaStateRecord();
export type ProViaState = typeof initialState;

const model = "provia";

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.getIn([model])) {
    state = state.setIn([model], initialState);
  }

  switch (action.type) {
    case SET_PROVIA_LOADING:
      return state.setIn([model, "loading"], action.payload);

    case RECEIVE_PROVIA_ORDERS:
      return state.setIn([model, "orders"], List(action.payload.map(proviaOrderSummaryFromJSON)));

    case RECEIVE_PROVIA_ORDER:
      return state.setIn([model, "order"], proViaOrder2FromJSON(action.payload));

    case RESET_PROVIA_STATE:
      return state.setIn([model], initialState);

    case OPEN_PROVIA_MODAL:
      return state
        .setIn([model, "modalMode"], action.payload.mode)
        .setIn([model, "modalEstimateGroupId"], action.payload.estimateGroupId);

    default:
      return state;
  }
};
